var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"numberbox",domProps:{"textContent":_vm._s(_vm.animatedNumber)}})
}
var staticRenderFns = []

export { render, staticRenderFns }